import { render, staticRenderFns } from "./RelatorioAniversariantesForm.vue?vue&type=template&id=f3f12354&scoped=true&"
import script from "./RelatorioAniversariantesForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioAniversariantesForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioAniversariantesForm.vue?vue&type=style&index=0&id=f3f12354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f12354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
